import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { HttpService } from '../shared/services/http.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { ControllerService } from '../shared/services/controller.service';

@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.scss'],
  standalone: false
})
export class TemplateComponent implements OnInit {

  templates: any = [];
  dataSource: any

  displayedColumns: string[] = ['code', 'description', 'content'];
  @ViewChild(MatSort, { static: true }) sort: MatSort = new MatSort();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  page = 0
  size = 10
  count = 0
  loading = false
  templateFilter = ''

  filterDebounce: any

  @ViewChild('filterInput', { static: false }) filterInput: any;

  clientParam = ''

  code: any = null

  constructor(private httpService: HttpService, private router: Router, public controller: ControllerService) {

  }

  skeletonRows: number[][] = [];

  generateSkeletonRows() {
    this.skeletonRows = Array(10).fill(0).map(() => {
      // Random number of bars between 5 and 8 to ensure density
      const barCount = Math.floor(Math.random() * (8 - 5 + 1)) + 5;
      const bars = [];
      for (let i = 0; i < barCount; i++) {
        // Random flex weight between 1 and 10 to give variety in width
        bars.push(Math.floor(Math.random() * 10) + 1);
      }
      return bars;
    });
  }

  async fetchTemplates() {
    this.loading = false
    this.generateSkeletonRows(); // Generate new random rows on fetch
    try {
      const sort = {
        active: this.sort.active,
        direction: this.sort.direction
      }

      // Wait for both the API call and at least 1 second
      const [resp]: [any, any] = await Promise.all([
        this.httpService.postAsync("hcode/listCodes", { stencil: true, page: this.page, size: this.size, filter: this.templateFilter, sort }),
        new Promise(resolve => setTimeout(resolve, 0))
      ]);

      if (resp.success) {
        this.templates = resp.codes
        this.count = resp.count
      }

    } finally {
      this.loading = false
    }

    this.dataSource.data.length = 0
    this.dataSource.data = this.templates
  }

  async onPaginateChange(event: PageEvent) {
    this.page = event.pageIndex;
    this.size = event.pageSize;
    await this.fetchTemplates();
  }

  loadContent(templateId) {

    const template = this.templates.find(({ id }) => id == templateId)
    if (!this.clientParam) {

      const client = this.controller.getClientName(template.client_id)
      this.clientParam = this.controller.getClientNameAsParam(client)
    }

    if (!this.clientParam) {
      console.error(template)
      alert("Client not found")
      return
    }

    this.router.navigate([`client/${this.clientParam}/code/${template.code}`])
  }

  newTemplate() {
    this.code = { description: '', active: true, stencil: true, clientId: 1 , use_stencil_id: null, expected_completion: '2100-01-01'}
  }

  closeCodeDetail(event: boolean) {
    this.code = null

    if (event) {
      this.fetchTemplates()
    }
  }

  filter(event) {

    if (this.filterDebounce) {
      window.clearTimeout(this.filterDebounce)
    }

    this.page = 0

    this.filterDebounce = window.setTimeout(async () => {
      this.templateFilter = event.target.value.trim()
      await this.fetchTemplates()
    }, 250)
  }

  async fetchClients() {
    try {
      const clients = await this.httpService.postAsync("hclient/listClients", {})

      this.controller.setClients(clients)
    } catch (e) {
      if (e.status == 402) {
        this.controller.redirectToSignIn()
        return
      }
    }

  }

  async ngOnInit() {
    await this.fetchClients()

    this.dataSource = new MatTableDataSource(this.templates);

    this.sort.sortChange.subscribe(() => {
      this.page = 0
      this.fetchTemplates()
    })

    this.controller.shiftContainerToTop()

    await this.fetchTemplates()
  }

}
